import { numberOfPsychologistsAcc } from "utils/infrastructure/wording-utils"

export function formatText(number: number) {
    return `Подобрали вам ${number} ${numberOfPsychologistsAcc(number)}`
}
